import SeasonalityChartEventLine from '@page-components/condensed-timeline/sales-forecast/SeasonalityChartEventLine';
import { DateUtility } from '@utility/date';
import {
  chartDisplayDate,
  colors,
  parseDate,
  referenceLineOptions,
} from '@utility/sales-forecast';
import { Fragment } from 'react';
import { Label, ReferenceArea, ReferenceLine } from 'recharts';

/**
 * SeasonalityChartSpikes component displaying seasonal spike dates and related visuals.
 * @param {string[]} props.seasonalSpikeDates - Array of seasonal spike dates.
 * @param {Object[]} props.seasonalSpike - Array of seasonal spike objects.
 * @param {string} props.eventId - The ID of the current event.
 * @param {Function} props.setEventId - Function to set the event ID.
 * @returns {JSX.Element[]} - React component rendering seasonal spike dates and visuals.
 *
 * @see {@link https://recharts.org/en-US/api/ReferenceLine | ReferenceLine Documentation}
 * @see {@link https://recharts.org/en-US/api/ReferenceArea | ReferenceArea Documentation}
 */
function SeasonalityChartSpikes(props) {
  const {
    eventId = '',
    seasonalSpike = [],
    seasonalSpikeDates = [],
    setEventId = () => {},
  } = props;

  return (
    <>
      {seasonalSpikeDates.map(d => {
        // Find Data
        const selected = seasonalSpike.find(c => parseDate(c.from) === d);

        // Event Selected -> Force Render Area
        const opacity = eventId && eventId === selected._id ? '1' : '0';

        let fixedDate = d;

        if (DateUtility.isDateAfter(new Date(), d)) {
          fixedDate = new Date();
        }

        const xAxisId = chartDisplayDate(fixedDate);

        return (
          <Fragment key={`seasonalSpikeDates-${d}`}>
            {/* Reference line for seasonal spike */}
            <ReferenceLine
              x={xAxisId}
              {...referenceLineOptions}
              stroke={colors.seasonalSpike.background}
              label={
                <Label
                  x={xAxisId}
                  content={
                    <SeasonalityChartEventLine
                      position="right"
                      isSeasonal
                      setEventId={setEventId}
                      eventId={eventId}
                    />
                  }
                  // @ts-expect-error - TS2322: Type '{ x: string; content: Element; data: any; }' is not assignable to type 'In...
                  data={selected}
                />
              }
            />

            {/* Reference area for seasonal spike */}
            <ReferenceArea
              animationDuration={150}
              fill={colors.seasonalSpike.font}
              fillOpacity={0.1}
              id={`event-${selected._id}`}
              ifOverflow="visible"
              isFront
              style={{ opacity }}
              x1={xAxisId}
              x2={chartDisplayDate(selected.to)}
            />
          </Fragment>
        );
      })}
    </>
  );
}

export default SeasonalityChartSpikes;
